import withEntity from '@/entity/components/with-entity';

import InvestorProfileFields from './investor-profile-fields';

export default withEntity(InvestorProfileFields);
